import { CountUp } from "countup.js";

document.querySelectorAll(".stat-value").forEach((element) => {
  const value = parseFloat(element.dataset.countValue);
  const unit = element.dataset.countUnit;
  const delay = element.dataset.countDelay;

  // Check if mobile
  const isMobile = window.innerWidth < 960;

  const counter = new CountUp(element, value, {
    duration: 2.5,
    suffix: unit,
    startVal: 0,
  });

  // Apply delay only on desktop
  const actualDelay = isMobile ? 0 : delay;

  // Trigger on scroll/visibility after delay
  setTimeout(() => {
    counter.start();
  }, actualDelay);
});
